import {
	FaFacebook,
	FaGithub,
	FaInstagram,
	FaLinkedin,
	FaTwitter,
} from "react-icons/fa";

function SocialIcons() {
	return (
		<div className='flex space-x-6'>
			<a
				href='https://twitter.com/izimartinz/'
				target='blank'
				className='text-gray-700 hover:text-blue-500'>
				<FaTwitter size={24} />
			</a>
			<a
				href='https://web.facebook.com/Izimartinz/'
				target='blank'
				className='text-gray-700 hover:text-blue-500'>
				<FaFacebook size={24} />
			</a>
			<a
				href='https://instagram.com/izimartin/'
				target='blank'
				className='text-gray-700 hover:text-pink-500'>
				<FaInstagram size={24} />
			</a>
			<a
				href='https://github.com/izimartin/'
				target='blank'
				className='text-gray-700 hover:text-gray-900'>
				<FaGithub size={24} />
			</a>
			<a
				href='https://www.linkedin.com/in/izimartin/'
				target='blank'
				className='text-gray-700 hover:text-blue-600'>
				<FaLinkedin size={24} />
			</a>
		</div>
	);
}

export default SocialIcons;
